import React from 'react';
import { Table, Button, Space, Modal, message, Card, Switch } from 'antd';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../../api/axios';

export const OleSlidersList: React.FC = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { data: sliders, isLoading } = useQuery({
        queryKey: ['adminOleSliders'],
        queryFn: async () => {
            const response = await apiClient.get('/admin/ole/sliders');
            return response.data.data;
        }
    });

    const deleteMutation = useMutation({
        mutationFn: async (id: string) => {
            const response = await apiClient.delete(`/admin/ole/sliders/${id}`);
            return response.data;
        },
        onSuccess: () => {
            message.success('Slide başarıyla silindi');
            queryClient.invalidateQueries({ queryKey: ['adminOleSliders'] });
        },
        onError: () => {
            message.error('Slide silinirken hata oluştu');
        }
    });

    const handleDelete = (id: string) => {
        Modal.confirm({
            title: 'Slide Sil',
            content: 'Bu slide ögesini silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
            okText: 'Sil',
            okType: 'danger',
            cancelText: 'Vazgeç',
            onOk: () => deleteMutation.mutate(id)
        });
    };

    const columns = [
        {
            title: 'Görsel',
            dataIndex: 'imageUrl',
            key: 'imageUrl',
            width: 150,
            render: (url: string) => (
                <img 
                    src={url} 
                    alt="Slide" 
                    style={{ width: '120px', height: '60px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #f0f0f0' }} 
                />
            )
        },
        {
            title: 'Başlık (DE)',
            dataIndex: 'title',
            key: 'title',
            render: (text: string) => <span style={{ fontWeight: 600 }}>{text || '-'}</span>
        },
        {
            title: 'Yönlendirme Hedefi (CTA)',
            dataIndex: 'ctaTarget',
            key: 'ctaTarget',
            render: (text: string) => <code>{text || '-'}</code>
        },
        {
            title: 'Sıra',
            dataIndex: 'orderIndex',
            key: 'orderIndex',
            width: 100,
        },
        {
            title: 'Aktif',
            dataIndex: 'isActive',
            key: 'isActive',
            width: 100,
            render: (isActive: boolean) => (
                <Switch checked={isActive} disabled />
            )
        },
        {
            title: 'Aksiyonlar',
            key: 'actions',
            width: 120,
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button 
                        type="primary" 
                        icon={<EditOutlined />} 
                        onClick={() => navigate(`/admin/ole/sliders/edit/${record.id}`)}
                    />
                    <Button 
                        danger 
                        icon={<DeleteOutlined />} 
                        onClick={() => handleDelete(record.id)}
                    />
                </Space>
            )
        }
    ];

    return (
        <Card 
            title="OLE Slider Yönetimi" 
            extra={
                <Button 
                    type="primary" 
                    icon={<PlusOutlined />} 
                    onClick={() => navigate('/admin/ole/sliders/create')}
                >
                    Yeni Slide Ekle
                </Button>
            }
        >
            <Table
                columns={columns}
                dataSource={sliders}
                rowKey="id"
                loading={isLoading}
                pagination={{ pageSize: 10 }}
            />
        </Card>
    );
};
